function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class ParseUrlResult {
  constructor() {
    _defineProperty(this, "isValid", false);
    _defineProperty(this, "provider", '');
    _defineProperty(this, "id", '');
  }
}
const PROVIDER_URL_PATTERNS = [{
  provider: 'youtube',
  regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))([\w-]{11})(?:\S+)?$/
}, {
  provider: 'youtube',
  regex: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/shorts\/)([\w-]{11})(?:\S+)?$/
}, {
  provider: 'vimeo',
  regex: /vimeo\..*?\/(\d+)\/([\w-]+)/i
}, {
  provider: 'vimeo',
  regex: /vimeo\..*?\/(\d+)\?h=([\w-]+)/i
}, {
  provider: 'vimeo',
  regex: /vimeo\..*?\/(\d+)(?:\/)?/i
}, {
  provider: 'wistia',
  regex: /wistia\..*\/([^?]+)\??.*/i
}, {
  provider: 'loom',
  regex: /(?:use)?loom\..*\/([^?]+)\??.*/i
}, {
  provider: 'vidyard',
  regex: /vidyard\..*\/([^?]+)\??.*/i
}, {
  provider: 'brightcove',
  regex: /players\.brightcove\.net\/([^\/]+)\/.*videoId=([\w-]+)/i
}, {
  provider: 'jwplayer',
  regex: /(?:cdn|content)\.jwplatform\.com\/players\/([\w-]+)\.html/i
}, {
  provider: 'microsoftstream',
  regex: /web\.microsoftstream\.com\/embed\/video\/([\w-]+)/i
}, {
  provider: 'microsoftstream',
  regex: /^(?:https?:\/\/)?([\w-]+)\.sharepoint\.com\/:v:\/(.*)/i
}, {
  provider: 'synthesia',
  regex: /share\.synthesia\.io\/embeds\/videos\/([\w-]+)/i
}, {
  provider: 'synthesia',
  regex: /share\.synthesia\.io\/([\w-]+)/i
}, {
  provider: 'guidde',
  regex: /embed\.app\.guidde\.com\/playbooks\/([\w-]+)/i
}, {
  provider: 'descript',
  regex: /share\.descript\.com\/(?:embed|view)\/([\w-]+)/i
}, {
  provider: 'guideflow',
  regex: /app\.guideflow\.com\/(?:embed|video|player)\/([\w-]+)/i
}];
const ID_SEPARATOR = '|';
export function parseUrl(url) {
  let result = new ParseUrlResult();
  if (url) {
    url = url.trim();
    PROVIDER_URL_PATTERNS.some(pattern => {
      let match = url.match(pattern.regex);
      if (match) {
        let [, ...ids] = match;
        result.provider = pattern.provider;
        result.id = ids.join(ID_SEPARATOR);
        result.isValid = true;
        return true;
      } else {
        return false;
      }
    });
  }
  return result;
}

// To support all the insertable videos, this method should always match the corresponding interblocks method:
// https://github.com/intercom/interblocks.ts/blob/ba17d13bf21f9ee1246ea82999716bfe87de216b/src/parse/v1/blocks/video.ts
export function generateVideoUrl(provider, joinedIds) {
  let [id, ...otherIds] = joinedIds.split(ID_SEPARATOR);
  switch (provider) {
    case 'youtube':
      return `https://www.youtube.com/embed/${id}?rel=0`;
    case 'vimeo':
      return otherIds.length === 0 ? `https://player.vimeo.com/video/${id}` : `https://player.vimeo.com/video/${id}?h=${otherIds[0]}`;
    case 'wistia':
      return `https://fast.wistia.net/embed/iframe/${id}`;
    case 'loom':
      return `https://www.loom.com/embed/${id}`;
    case 'vidyard':
      return `https://play.vidyard.com/${id}`;
    case 'brightcove':
      return `https://players.brightcove.net/${id}/default_default/index.html?videoId=${otherIds[0]}`;
    case 'jwplayer':
      return `https://content.jwplatform.com/players/${id}.html`;
    case 'microsoftstream':
      return otherIds.length === 0 ? `https://web.microsoftstream.com/embed/video/${id}` : `https://${id}.sharepoint.com/:v:/${otherIds[0]}`;
    case 'synthesia':
      return `https://share.synthesia.io/embeds/videos/${id}`;
    case 'guidde':
      return `https://embed.app.guidde.com/playbooks/${id}`;
    case 'descript':
      return `https://share.descript.com/embed/${id}`;
    case 'guideflow':
      return `https://app.guideflow.com/embed/${id}`;
    default:
      throw new Error(`Video provider ${provider} not supported`);
  }
}